export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-960-079062290fbb138908dc279627df81ba.webp";